/* eslint-disable-next-line no-restricted-imports */
import qs, { StringifyOptions, ParsedQuery, ParseOptions, ParsedUrl } from 'query-string';

const sharedOptions = {
  // 'comma' and 'separator' values will cause single item arrays to be parsed as follows: portal_ids=123 => portal_ids: 123 instead of portal_ids: [123]
  //also 'comma' and 'separator' values convert array of objects to [[object Object]] 
  //related issues: https://github.com/ljharb/qs/issues/315, https://github.com/ljharb/qs/issues/378
  arrayFormat: 'bracket-separator',
  arrayFormatSeparator: '|',
  parseNumbers: true, // needed for filters sending option ids to BE e.g. broker ids, carrier ids etc
  parseBooleans: true // needed for boolean filter values to be actually boolean and not strings (parseBooleans: false => filterName: "true/false")
} as StringifyOptions | ParseOptions;

interface ObjectUrlParams {
  [key: string]: any;
}

export const stringifyUrlParams = (object: ObjectUrlParams): string => {
  return qs.stringify(object, sharedOptions);
};

const DEFAULT_RESTRICTED_PARSING_FIELDS = ['query'];

export const parseUrlParams = <T = ParsedQuery<any>>(params: string, restrictedParsingFields: string[] = []): T => {
  const parsedParams = qs.parse(params, sharedOptions);

  const restrictedKeys = [...DEFAULT_RESTRICTED_PARSING_FIELDS, ...restrictedParsingFields];

  const allParamsWithoutOptions = qs.parse(params, { arrayFormat: 'bracket-separator', arrayFormatSeparator: '|' });

  const parsedWithoutOptions = restrictedKeys.reduce((acc, key) => {
    if (allParamsWithoutOptions[key]) acc[key] = allParamsWithoutOptions[key];
    return acc;
  }, {} as ParsedQuery<any>);

  return { ...parsedParams, ...parsedWithoutOptions } as T;
};

export const stringifyFullUrl = (urlObj: ParsedUrl): string => {
  return qs.stringifyUrl(urlObj);
};

export const serializeHttpParams = (params: Record<string, any>): string => {
  const serializedParams: Record<string, string> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (typeof value === 'object' && !Array.isArray(value)) {
      serializedParams[key] = JSON.stringify(value);
    } else {
      serializedParams[key] = value;
    }
  });

  return qs.stringify(serializedParams, {
    arrayFormat: 'bracket',
    parseNumbers: true,
    parseBooleans: true,
  } as StringifyOptions | ParseOptions);
};
